import Cookies from 'js-cookie'
import 'select2';
import jwt_decode from "jwt-decode";

import {clearSearch} from "./blocks/autocomplete";
import {taxFilter} from "./blocks/tax-filter";
import {makeAutocomplete} from "./blocks/autocomplete";
import {heroSlider} from "./blocks/hero-slider";
import {productSlider} from "./blocks/product-slider";
import {createSourceSlider} from "./blocks/sources-slider";
import {partnersSlider} from "./blocks/partners-slider";
import {productTabs} from "./blocks/tabs";
import {account} from "./account";
import {
    loadElementLottie,
    playLottie}from "./animations/lottie";
import {closeBook, openBook, toggleBook} from "./book";
import {
    changeProductQuantity,
    registerUser,
    loginUser,
    removeFromCart,
    forgotPassword,
    updateProfile,
    updatePassword,
    updateAddress,
    deleteUser,
    subscribe,
    addToCart,
    stopDownloadCountdown
} from "./api";
import {
    loginFacebook,
    loginGoogle} from "./soc_logins";

let html = $("html");
let body = $("body");
let allow_cookies = false;

let W = window.innerWidth
let H = window.innerHeight

let slider_latest;
let slider_popular;

$(document).ready(function () {
    console.log('doc ready');
    body = $("body");
    html = $("html");

    body.addClass('doc-ready');

    if(!html.hasClass('account')) {

    }

    const lazy = new LazyLoad();

    let side_menu = $(".js-main-menu");
    let filter_window = $(".tax-filter-window");
    let fast_checkout = $(".fast-checkout");

    let originalColor = side_menu.css("background-color");
    let cart = $(".js-load-lottie-cart");

    loadElementLottie(cart);

    if(W > 600) {

        $('.select select').select2({
            minimumResultsForSearch: -1,
            width: '100%',
            theme: "outlined"
        });

    }

    if(Cookies.get('cookie_essential') ) {
        allow_cookies = true;
    }

    if(Cookies.get('cookie_marketing') ) {
        $("#cookie_marketing").attr("checked",true);
    } else {
        body.addClass('no-marketing');
    }

    if(Cookies.get('cookie_analytical') ) {
        $("#cookie_analytical").attr("checked",true);
    } else{
        body.addClass('no-analytical');
    }

    if(!allow_cookies) {
        body.addClass("show-cookies");
    }

    $(".button.button--cart").on({
        mouseenter: function () {
            if ( window.innerWidth > 1279 ) {
                playLottie(cart)
            }
        },
        mouseleave: function () {}
    });

    $("form#subscribe").on("submit", function (e) {
        e.preventDefault()
        let me = $(this)
        let data = me.serializeArray()
        let input = me.find("input")
        let mail = data[0].value
        let but = me.find("span")

        let text_error = me.data("text-error")
        let text_button = me.data("text-button")

        let validate = validateEmail(mail)

        if(validate) {
            console.log("Validating from ready")
            subscribe(me, data)
        } else {
            me.addClass("error")
        }

        if(me.hasClass("error")) {

            setTimeout(function () {
                me.addClass("show-error")
                but.text(text_error)
                input.val("")
            },500);

            setTimeout(function () {
                me.removeClass("error show-error")
                but.text(text_button)
            },1400);

        }

        return false;
    });

    $("form#woo_login").on("submit", function () {
        let me = $(this);
        let data = me.serializeArray();
        loginUser(me,data);
        return false;
    });

    $("form#woo_register").on("submit", function () {
        let me = $(this);
        let data = me.serializeArray();
        registerUser(me,data);
        return false;
    });

    $("form#woo_forgot_password").on("submit", function () {
        let me = $(this);
        let data = me.serializeArray();
        forgotPassword(me,data);
        return false;
    });

    $("form#woo_update_profile").on("submit", function () {
        let me = $(this);
        let data = me.serializeArray();
        updateProfile(me,data);
        return false;
    });

    $("form#woo_update_password").on("submit", function () {
        let me = $(this);
        let data = me.serializeArray();
        updatePassword(me,data);
        return false;
    });

    $("form#woo_update_address").on("submit", function () {
        let me = $(this);
        let data = me.serializeArray();
        updateAddress(me,data);
        return false;
    });

    $("form#woo_delete_user").on("submit", function () {
        let me = $(this);
        let data = me.serializeArray();
        deleteUser(me,data);
        return false;
    });

    $("form#allow_cookies").on("submit", function () {
        let me = $(this);
        let data = me.serializeArray();
        let formData = {}
        // console.log(data);

        $.each(data, function () {

            if (this.value) {
                formData[this.name] = this.value;
            }

        });

        if(formData) {

            formData.cookie_essential == "on";

            Cookies.remove("cookie_marketing");
            Cookies.remove("cookie_analytical");

            $.each(formData, function( name, val ) {

                if(name !== "cookie_essential") {
                    console.log(name)
                }

                if(name && val == "on") {
                    console.log(name,val)

                    Cookies.set(name, val, {
                        expires: 32
                    })
                }

            });

        }

        body.removeClass("show-cookies");

        return false;
    });

    if (W < 1280) {

        updateSizes(side_menu,filter_window,fast_checkout);

        $(".category-grid__wrapper .card--category").on("click tap", function() {
            window.location.href = $(this).attr("href");
            return false;
        });

    } else {
        side_menu.css("right","auto");

        side_menu.find('li')
            .mouseover(function () {
                let color = $(this).data('color')
                let currColor = side_menu.css("background-color")

                if ( window.innerWidth > 1279 ) {
                    $(this).css('opacity', 1).siblings().css('opacity', 0.3)
                    side_menu.css("background-color", color)
                }

            })
            .mouseout(function () {
                let currColor = side_menu.css("background-color")

                if ( window.innerWidth > 1279 ) {
                    side_menu.css("background-color", originalColor)
                    $(".main-menu__body .main-menu__item").css('opacity', 1);
                }

            });

        body.addClass("isDesktop");
    }

    taxFilter();

    if ( body.hasClass("page-template-page-home") ) {

        let hash = window.location.hash;

        if(hash.substring(1) == "login") {
            body.addClass("show-fast-login");
        }

        heroSlider();
        partnersSlider();

        slider_latest = createSourceSlider("latest-products-slider")
        slider_popular = createSourceSlider("popular-products-slider")

    }

    if ( body.hasClass("page-template-page-text") ) {
        let attachment = $(".attachment");

        attachment.each(function () {
            let me = $(this);
            let el = me.find(".js-load-lottie-download")
            loadElementLottie(el)

            me.on({
                mouseenter: function () {
                    if ( window.innerWidth > 1279 ) {
                        playLottie(el)
                    }
                },
                mouseleave: function () {}
            });

        });

    }

    if ( body.hasClass("single-product") ) {
        let but_add_to_cart = $("a.but.add-to-cart");

        toggleBook()
        productSlider()
        productTabs()
        createSourceSlider("related-products")

        let p_count = $(".p-options .p-count");

        if(p_count.find("span").text() == "1") {
            p_count.find("a.down").addClass("disabled");
        }

        p_count.find("a").on("click tap", function() {
            let me = $(this)
            let parent = me.parent()
            let quantity = parent.find("span").text()
            let id = parent.data("id")
            let max_q = parent.data("max-quant")
            quantity = parseInt(quantity)

            if(me.hasClass("up")) {

                if(quantity < max_q) {
                    quantity++
                }
            }

            if(me.hasClass("down")) {

                if(quantity > 1) {
                    quantity--
                }

            }

            parent.find("span").text(quantity)

            if(parent.find("span").text() !== "1") {
                parent.find("a.down").removeClass("disabled");
            } else {
                parent.find("a.down").addClass("disabled");
            }

            console.log(quantity, id)

            return false;
        });

        but_add_to_cart.on({
            mouseenter: function () {
                if ( window.innerWidth > 1279 ) {
                    playLottie(but_add_to_cart.find(".js-load-lottie-cart"))
                }
            },
            mouseleave: function () {}
        });

    }

    if(body.hasClass("page-template-search")) {
        makeAutocomplete("#autocomplete_inline","#search_results_inline","#search_bar_inline",true,".search-bar.inline")
        slider_latest = createSourceSlider("latest-products-slider")
        slider_popular = createSourceSlider("popular-products-slider")
    }

    if(html.hasClass("account")) {
        account()
    }

});

$(document).on("click tap", ".soc-logins a", function() {
    let me = $(this);

    if(me.hasClass("facebook")) {
        loginFacebook(me);
        return false;
    }

    if(me.hasClass("google")) {
        return false;
    }

    if(me.hasClass("skip-register")) {
        return true;
    }

});

$(document).on("click tap", ".button, article", function() {

    let me = $(this);
    let href = me.attr("href");

    if (href) {
        let target = me.attr("target");

        if ( target ) {
            let a = document.createElement('a');
            a.href = href;
            a.target= target;
            a.click();
        } else {
            window.location.href = href;
        }

    }

    return false;

});

$(document).on("click tap",".js-mobile-toggle", function() {
    var me = $(this)
    var t = me.find(".t")
    var text_open = me.data("open-text")
    var text_close = me.data("close-text")
    html.toggleClass('menu-opened')

    if(html.hasClass('menu-opened')) {
        t.text(text_close)
        body.removeClass("show-filter-window");

        if ( window.innerWidth < 1279 ) {
            // $(".header").removeClass("show");
            // $(".header").addClass("is-hidden");
            $(".tax-filter-mobile").removeClass("sticky");
        }

        setTimeout(function() {
            me.parent().removeClass('is-hidden');
        }, 500);

    } else {
        t.text(text_open)
    }

});

$(document).on("click tap",".fast-checkout a.but", function() {

    if(is_logged) {
        return true;
    } else {
        $("body").removeClass("show-fast-checkout menu-opened");
        $("body").addClass("show-fast-login free-download");
        $(".mobile-menu-toggle").addClass("is-hidden");
        return false;
    }
});

$(document).on("click tap",".fast-checkout .p-count a", function() {
    let me = $(this)
    let parent = me.parent()
    let quantity = parent.find("span").text()
    let key = parent.data("key")
    let max_q = parent.data("max-quant")
    quantity = parseInt(quantity)

    if(me.hasClass("up")) {

        if(max_q) {
            if(quantity < max_q) {
                quantity++
                console.log(quantity)
                changeProductQuantity(me,key,quantity,max_q)
            }
        } else {
            quantity++
            console.log(quantity)
            changeProductQuantity(me,key,quantity,max_q)
        }

    }

    if(me.hasClass("down")) {

        if(quantity > 1) {
            quantity--
            changeProductQuantity(me,key,quantity,max_q)
        }

    }

    return false;
});

$(document).on("click tap",".fast-checkout a.remove-from-cart", function() {
    let me = $(this)
    let id = me.data("id")
    removeFromCart(me,id)
    return false;
});

$(document).on("click tap","form#subscribe button", function() {
    $("form#subscribe").submit();
    return false;
});

$(document).on("click tap", "#woo_login .submit-form .button_2", function(e) {
    $("form#woo_login").submit();
    return false;
});

$(document).on("click tap", "#woo_register .submit-form .button_2", function(e) {
    $("form#woo_register").submit();
    return false;
});

$(document).on("click tap", "#woo_forgot_password .submit-form .button_2", function(e) {
    $("form#woo_forgot_password").submit();
    return false;
});

$(document).on("click tap", "#woo_update_profile .submit-form .button_2", function(e) {
    $("form#woo_update_profile").submit();
    return false;
});

$(document).on("click tap", "#woo_update_password .submit-form .button_2", function(e) {
    $("form#woo_update_password").submit();
    return false;
});

$(document).on("click tap", "#woo_update_address .submit-form .button_2", function(e) {
    $("form#woo_update_address").submit();
    return false;
});

$(document).on("click tap", "#woo_delete_user .submit-form .button_2", function(e) {
    $("form#woo_delete_user").submit();
    return false;
});

$(document).on("click tap",".allow-cookies .buttons a", function() {
    let me  = $(this)
    let allow_cookies = $("#allow_cookies");

    if(me.hasClass("allow-all-cookies")) {
        allow_cookies.find("input").each(function() {
          let input = $(this)
          input.prop("checked", true)
        })

        setTimeout(function() {
            allow_cookies.submit();
        },300)

    } else if(me.hasClass("edit-cookies")) {
        me.removeClass("edit-cookies");
        me.addClass("save-cookies")
        me.find("span").text(me.data("text-save-cookies"))
        allow_cookies.stop().fadeIn("fast");
    } else {
        allow_cookies.submit();
    }

    return false;
});

$(document).on("click tap","a.agree-marketing-cookies", function() {

    Cookies.set("cookie_marketing", "on", {
        expires: 32
    })

    body.removeClass('no-marketing');

    return false;
});

$(document).on("click tap","a.cookies-settings", function() {
    body.addClass("show-cookies");
    $(".cookies-settings, .js-scroll-up").removeClass("show");
    return false;
});

$(document).on("click tap",".show-password", function() {
    let me = $(this);
    let input = me.parent().find("input");
    me.toggleClass("show");

    if (me.hasClass("show")) {
        input.attr("type","text");
    } else {
        input.attr("type","password");
    }

    return false;
});

$(document).on("click tap",".overlay", function() {
    body.removeClass("show-fast-checkout show-mobile-filter show-search free-download show-fast-login")
    html.removeClass("menu-opened")
    clearSearch()
    $(".mobile-menu-toggle").removeClass("is-hidden")
    $(".sidebars .body").scrollTop(0);
});

$(document).on("click tap",".header__search", function() {
    body.toggleClass("show-search")

    makeAutocomplete("#autocomplete","#search_results","#search_bar",false,".search-bar")

    if(body.hasClass("show-search")) {
        $("#autocomplete").focus()
        $(".mobile-menu-toggle").addClass("is-hidden");
    }

    clearSearch()

});

$(window).on("resize", function() {
    let side_menu = $(".js-main-menu");
    let filter_window = $(".tax-filter-window");
    let fast_checkout = $(".fast-checkout");
    updateSizes(side_menu,filter_window,fast_checkout);
    console.log("resize")
});

$(document).on("focus",".field input, .field textarea", function() {
    let me = $(this);
    focusInput(me, true);
});

$(document).on("blur",".field input, .field textarea", function() {
    let me = $(this);
    focusInput(me, false);
});

$(document).on("focus",".form-row input, .label .field input", function() {
    let me = $(this);
    focusInputWoo(me, true);
});

$(document).on("blur",".form-row input, .label .field input", function() {
    let me = $(this);
    focusInputWoo(me, false);
});

$(document).on("change","input.nice", function() {
    let me = $(this);
    console.log('Ready',me)
    if(!me.hasClass("disabled")) {
        if(me.is(':checked')) {
            me.parent().addClass("is-checked");
        } else {
            me.parent().removeClass("is-checked");
        }
    }

});

$(document).on("keydown keyup",".field input, .field textarea", function() {
    let me = $(this);
    let parent = me.parent();
    let val = me.val();
    let max_length = me.attr("maxlength");

    if ( val.length > 0 ) {
        parent.removeClass("error")
    }

    if ( val.length > max_length ) {
        parent.removeClass("error")
        val.substring(0, max_length);
    }

    if(me.closest(".has-count").hasClass("has-count")) {
        me.closest(".has-count").find(".count-letters p.current").text(val.length);
    }

});

$(document).on("click tap", ".button.button--auth", function(e) {
    askLogin();
    return false;
});

$(document).on("click tap", ".close-fast-login", function(e) {
    body.removeClass("show-fast-login free-download");
    $(".mobile-menu-toggle").removeClass("is-hidden");
    history.replaceState(null, null, ' ');
    return false;
});

$(document).on("click tap", ".close-countdown", function(e) {
    body.removeClass("show-download-countdown");
    return false;
});

$(document).on("click tap", ".popular-tabs a", function(e) {
    let me = $(this)
    let type = me.data("type")
    me.addClass("active").siblings().removeClass("active")
    console.log(type);

    $("#popular_free").hide();
    $("#popular_payed").hide();


    if(type === "free") {
        $("#popular_payed").removeClass("show");
        $("#popular_free").addClass("show");
        $("#popular_free").stop().delay(300).fadeIn("fast");

        slider_popular[1].slideTo(0,0);

        let slide = $("#popular_free .swiper-slide[data-swiper-slide-index='0']");

        let line = slide.find('.js-progress-line')

        slide.siblings().find('.js-progress-line').stop().animate(
            {width: 0
            }, 0, 'linear');

        line.animate({
            width: "100%"
        }, 3000, 'linear', function() {

            if(!line.hasClass("stoped")) {
                slider_popular[1].slideNext();
            }

        });

    }

    if(type === "payed") {
        $("#popular_payed").addClass("show");
        $("#popular_payed").stop().delay(300).fadeIn("fast");
        $("#popular_free").removeClass("show");

        slider_popular[0].slideTo(0,0);

        let slide = $("#popular_payed .swiper-slide[data-swiper-slide-index='0']");

        let line = slide.find('.js-progress-line')

        slide.siblings().find('.js-progress-line').stop().animate(
            {width: 0
            }, 0, 'linear');

        line.animate({
            width: "100%"
        }, 3000, 'linear', function() {

            if(!line.hasClass("stoped")) {
                slider_popular[0].slideNext();
            }

        });

    }


    return false
});

$(document).on("click tap", ".add-to-cart", function() {
    let me = $(this)
    let id = me.data("product-id")

    if(me.hasClass("has-amount")) {
        let amount = parseInt($(".woo-product-info .p-options .p-count span").text())
        addToCart(me, id, amount)
    } else {
        addToCart(me, id, 1)
    }

    return false;
});

$(document).on("click tap", ".download-book", function() {
    let me = $(this)
    console.log("download book", me)
    let href = me.attr("href")
    window.location.href = href
    stopDownloadCountdown();

    return false;
});

$(document).on("click tap", ".instant-checkout", function() {
    let me = $(this)
    let id = me.data("product-id")
    addToCart(me, id, 1)
    return false;
});

$(document).on("click tap", ".js-open-details", function() {
    let me = $(this);
    openBook(me)
    return false;
});

$(document).on("click tap", ".js-close-details", function() {
    let me = $(this);
    closeBook(me)
    return false;
});

$(document).on("click tap", ".link-with-icon", function() {
    console.log("link-with-icon")
    window.location.href = $(this).attr("href");
    return false;
});

$(document).on("click tap", ".card--book .perspective, .card--book .book-title", function() {
    let me = $(this)
    let href = me.data("href")
    window.location.href = href
    return false;
});

function askLogin() {
    body.addClass("show-fast-login");
    body.removeClass("show-search");
    html.removeClass("menu-opened");
    clearSearch()
    $(".mobile-menu-toggle").addClass("is-hidden");
}

function focusInput(me,status) {

    let parent = me.parent()

    if(status) {
        parent.addClass("focus");
        parent.addClass("focused");

        if(me.val() !== "") {
            parent.removeClass("focus");
        }

    } else {
        parent.removeClass("focus");
        parent.removeClass("focused");
    }

    if(me.val() !== "") {
        parent.addClass("focus");
    }

}

function focusInputWoo(me,status) {

    let parent = me.parent().parent()
    let name = me.attr('name');

    console.log(status)

    if(status) {
        parent.addClass("focus");
        parent.addClass("focused");

        if(me.val() !== "") {
            parent.removeClass("focus");
        }

    } else {
        parent.removeClass("focus");
        parent.removeClass("focused");
    }

    if(me.val() !== "") {
        parent.addClass("focus");
    }

}


// calculate font size
if (W > 1920 || (W > 1200 && W < 1350)) {
    setMainFontSize(W)

    window.addEventListener('resize', function(event){
        setMainFontSize(W)
    });
}

function setMainFontSize(W) {

    let fontCoef = W / 1920
    let fontSize = Math.floor(100 * fontCoef)

    if (W > 1200 && W < 1350) {
        fontSize = 90;
    }

    $('html').css('font-size', fontSize + '%')

}

function updateSizes(side_menu,filter_window,fast_checkout) {
    fast_checkout.css("right","-" + fast_checkout.outerWidth() + "px")
    side_menu.css("right","-" + side_menu.outerWidth() + "px");
    filter_window.css("right","-" + filter_window.outerWidth() + "px");
}

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

window.handleCredentialResponse = (response) => {
    let token = response.credential;

    if(token) {
        let data = jwt_decode(token);
        loginGoogle(data)
    } else {
        console.log("missing token");
    }
}